
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Page from './Page.vue';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import AllTimeTradeNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerCumulativeSalesNumberDisplayer.vue';
import YTDCustomerSalesNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerYtdSalesNumberDisplayer.vue';
import YTDCustomerSalesProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerYtdGrossProfitNumberDisplayer.vue';
import CurrentYearTradeNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerYtdRevenueContributionNumberDisplayer.vue';
import CurrentMonthCustomerSalesNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerMtdSalesNumberDisplayer.vue';
import CurrentMonthCustomerSalesProfitNumberDisplayer from '@/components/reports-v3/components/codedWidgets/customer/CustomerMtdGrossProfitNumberDisplayer.vue';
import CustomerSalesTrendBarLineChart from '@/components/reports-v3/components/codedWidgets/customer/CustomerSalesTrendLineChart.vue';
import LastSync from '@/components/LastSync.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import moment from 'moment';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import gdbx from '@/store/modules/gdbx';
import CustomerRadioFilter from '@/components/reports-v3/components/filters/CustomerRadioFilter.vue';
import SelectFilter from '@/components/reports-v3/components/filters/SelectFilter.vue';
import { ValueText } from '@/store/models.def';
import Message from 'primevue/message';
import SharedSalesAnalysisTreeMap from '@/components/reports-v3/components/codedWidgets/shared/SharedSalesAnalysisTreeMap.vue';
import Divider from 'primevue/divider';
import dbw from '@/worker/dbw';
import {getTableName} from '@/worker/db/sqlHelpers';

@Component({
	components: {
		CurrentMonthCustomerSalesNumberDisplayer,
		AllTimeTradeNumberDisplayer,
		YTDCustomerSalesNumberDisplayer,
		YTDCustomerSalesProfitNumberDisplayer,
		CurrentYearTradeNumberDisplayer,
		CurrentMonthCustomerSalesProfitNumberDisplayer,
		StickyFilterContainer,
		DateFilter,
		LastSync,
		CustomerRadioFilter,
		CustomerSalesTrendBarLineChart,
		SelectFilter,
		Message,
		SharedSalesAnalysisTreeMap,
		Divider,
	},
})
export default class Page1 extends Page {
	public accountManager: string = '';
	public relationship: string = 'No Record';
  public creditLimit: string = '';
  public customerCards = [];

	public async mounted() {
		this.track();
  const head = await dbw.loadTable('globalCustomers');
  const table = getTableName('globalCustomers');
  const escaped = this.defaultCustomer.replace(/'/g, '\'\'');
  const result = await head.rawQuery(`
      SELECT TRY_CAST("CREDITLIMIT" AS DOUBLE) as "creditLimit"
      FROM ${table}
      WHERE "CODE" = '${escaped}'
      LIMIT 1
  `);
  const limit = (result[0] && Number(result[0].creditLimit)) || 0;

  this.creditLimit = gdbx.currencySymbol + ' ' + limit.toLocaleString();

    // (this.$refs.stickyBottom as any).handleScroll();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public receivedAccountManager(value: string) {
		  this.accountManager = value;
	}

	public receivedRelationship(value: string) {
		this.relationship = value;
	}

	// public get selectedAsOfDate() {
	// 	return moment(this.selectedDay).endOf('month').valueOf();
	// }

	public get selectedCurrentMonthRange(): [number, number] {
		return [
			moment(this.selectedAsOfDate).startOf('month').valueOf(),
			moment(this.selectedAsOfDate).endOf('month').valueOf(),
		];
	}

	// public get selectedDateRange(): [number, number] {
	// 	return [
	// 		moment(this.selectedDay).startOf('year').valueOf(),
	// 		moment(this.selectedDay).endOf('year').valueOf(),
	// 	];
	// }
  //
	public get selectedYearToDateRange(): [number, number] {
		return [
			moment(this.selectedAsOfDate).startOf('year').valueOf(),
			moment(this.selectedAsOfDate).endOf('month').valueOf(),
		];
	}

	public get selectedStockItems() {
		return gdbx.allStockItems.map((vt) => vt.value);
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
